export default function(data) {
  var self = this;

  self.$el = $('#admin_master_record_listing');

  self.master_records = ko.observableArray();
  self.total_records = ko.observable();
  self.paginator = ko.observable();
  self.searchQuery = ko.observable();

  self.bindData = function(data) {
    var mapped_master_records = ko.mapping.fromJS(data.master_records);
    self.total_records(data.total_records);

    self.master_records(mapped_master_records());
    self.paginator(data.paginator);
  };

  self.initUI = function() {
    self.bindPaginationEvents();

    $('#courseSearch').on('keypress', function(event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13') {
        $('#courseSearch').blur();
        self.filterChanged();
      }
    });
  };

  self.filterChanged = function() {
    self.recordsListing(null, { q: self.searchQuery() });
  };

  self.bindPaginationEvents = function() {
    self.page_number = $('.page_number');
    var total_pages = parseInt($('.total_pages').text()),
      current_page = parseInt($('.current_page').text());

    self.page_number.keyup(function(e){
      if(e.keyCode == 13){
        changePage($(this).val());
      }
    });
    self.page_number.blur(function(e){
      changePage($(this).val());
    });

    $('.pagination a').off('click');
    $('.pagination a').on('click', function() {
      var url = $(this).attr('href');
      if (url != '#') {
        self.recordsListing(url);
      }
      return false;
    });

    var changePage = function(pageNumber){
      if (parseInt(pageNumber)) {
        var destination_page = (pageNumber <= total_pages) ? pageNumber : total_pages;
        var url = Kadenze.Routes.admin_courses_path() + '?page=' + destination_page;
        self.recordsListing(url);
      } else {
        self.page_number.val(current_page);
      }
    };

  };

  /*----------------------------------------COURSE SEARCH/FILTERING FUNCTIONS-----------------------------------------*/

  self.recordsListing = function (url, params) {
    var request,
      requestUrl = url ? url : Kadenze.Routes.admin_course_master_records_path();

    request = new Kadenze.AjaxRequest({
      type: 'GET',
      dataAsJSON: false,
      url: requestUrl,
      data: params,
      loadingIndicator: {
        container: self.$el
      }
    });


    request.done(function(data) {
      self.bindData(data);
      self.bindPaginationEvents();
      Kadenze.Layout.update(); // Helps reset the footer / sidebar when there's dramatic changes in the course list lengths
    });

    request.fail(function(data) {
      console.warn('Failed to get master records: ', data);
      new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
    });
  };

  const __construct = function(that) {
    console.log('constructor called for AdminMasterRecordListingViewModel');
    that.bindData(data);
  }(this);
}
